var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-image',_vm._b({staticStyle:{"display":"block"},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('div',{staticClass:"loading_bg"})]},proxy:true}])},'van-image',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }